module.exports = __webpack_public_path__ + "img/preston_williams.f832e105.png";